export function Skeleton({ w = '100%', h = '12px', radius = '4px', className = '', style }) {
  return (
    <div
      className={`sp-skeleton ${className}`}
      style={{
        width: w,
        height: h,
        borderRadius: radius,
        ...style,
      }}
    />
  );
}

export function SkeletonText({ lines = 1, w = '100%', lastW = '70%' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} w={i === lines - 1 ? lastW : w} h="11px" />
      ))}
    </div>
  );
}

export function SkeletonRow({ cols = 5, height = '44px' }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: '1px solid var(--border)',
        height,
      }}
    >
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} w={i === 0 ? '32%' : '14%'} h="11px" />
      ))}
    </div>
  );
}

export function SkeletonCard({ lines = 3, height }) {
  return (
    <div
      className="ds-card"
      style={{
        padding: '14px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        ...(height ? { height } : {}),
      }}
    >
      <Skeleton w="40%" h="13px" />
      <SkeletonText lines={lines} />
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="ds-card" style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Skeleton w="50%" h="9px" />
      <Skeleton w="60%" h="20px" />
    </div>
  );
}
